function formatArrivalEstimate(estimatedDate, today) {
  if (typeof estimatedDate !== 'string') return null;

  const matched = estimatedDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!matched) return null;

  const year = Number(matched[1]);
  const month = Number(matched[2]);
  const day = Number(matched[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  const base = today || new Date();
  const estimatedValue = year * 10000 + month * 100 + day;
  const todayValue = base.getFullYear() * 10000 + (base.getMonth() + 1) * 100 + base.getDate();
  if (estimatedValue <= todayValue) return null;

  if (day <= 15) return `${month}月下旬頃入荷予定`;
  return `${(month % 12) + 1}月頃入荷予定`;
}

if (!customElements.get('delivery-date-component')) {
  customElements.define(
    'delivery-date-component',
    class extends HTMLElement {
      connectedCallback() {
        this._postalInput = this.querySelector('[data-postal-input]');
        this._resultDt = this.querySelector('[data-result-dt]');
        this._resultRow = this.querySelector('[data-result-row]');
        this._resultText = this.querySelector('[data-result-text]');
        this._loadingRow = this.querySelector('[data-loading-row]');
        this._errorRow = this.querySelector('[data-error-row]');
        this._addressHint = this.querySelector('[data-address-hint]');

        this._shippingFeeDt = this.querySelector('[data-shipping-fee-dt]');
        this._shippingFeeRow = this.querySelector('[data-shipping-fee-row]');
        this._shippingFeeText = this.querySelector('[data-shipping-fee-text]');

        this._currentPrefectureCode = null;
        this._shippingFeeReqId = 0;

        const productBlocks = this.closest('.product-blocks') || this.closest('section');
        const quantityInput = productBlocks ? productBlocks.querySelector('[data-quantity-input]') : document.querySelector('[data-quantity-input]');
        this._quantityInput = quantityInput;
        this._currentQuantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        this._qtyDebounceTimer = null;
        this._onQuantityChange = (e) => {
          const newQty = parseInt(e.target.value, 10) || 1;
          if (newQty !== this._currentQuantity) {
            this._currentQuantity = newQty;
            if (this._currentPrefectureCode) {
              clearTimeout(this._qtyDebounceTimer);
              this._qtyDebounceTimer = setTimeout(() => {
                this.fetchShippingFee();
              }, 300);
            }
          }
        };
        if (this._quantityInput) {
          this._quantityInput.addEventListener('change', this._onQuantityChange);
          this._quantityInput.addEventListener('input', this._onQuantityChange);
        }

        // 7桁入力で自動発火（300msデバウンス）
        let _debounceTimer;
        this._postalInput.addEventListener('input', () => {
          const digits = this._postalInput.value.replace(/-/g, '').replace(/\D/g, '');
          clearTimeout(_debounceTimer);
          if (digits.length === 7) {
            this._postalInput.blur(); // キーボードを閉じる
            _debounceTimer = setTimeout(() => {
              this.fetchDelivery();
              this.fetchAddress(digits);
            }, 300);
          } else {
            if (this._addressHint) {
              this._addressHint.textContent = '';
              this._addressHint.hidden = true;
            }
            this.clearShippingFee();
          }
        });

        // 初期表示時に自動取得
        const initialDigits = this._postalInput.value.replace(/-/g, '').replace(/\D/g, '');
        if (initialDigits.length === 7) {
          this.fetchDelivery();
          this.fetchAddress(initialDigits);
        }
      }

      disconnectedCallback() {
        if (this._onQuantityChange && this._quantityInput) {
          this._quantityInput.removeEventListener('change', this._onQuantityChange);
          this._quantityInput.removeEventListener('input', this._onQuantityChange);
        }
        if (this._qtyDebounceTimer) {
          clearTimeout(this._qtyDebounceTimer);
        }
      }

      clearShippingFee() {
        this._currentPrefectureCode = null;
        if (this._qtyDebounceTimer) {
          clearTimeout(this._qtyDebounceTimer);
          this._qtyDebounceTimer = null;
        }
        if (this._shippingFeeDt) this._shippingFeeDt.hidden = true;
        if (this._shippingFeeRow) this._shippingFeeRow.hidden = true;
        if (this._shippingFeeText) {
          this._shippingFeeText.textContent = '';
          this._shippingFeeText.style.color = '';
        }
      }

      async fetchAddress(digits) {
        if (!this._addressHint) return;
        try {
          const res = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${digits}`);
          const data = await res.json();
          if (data.results && data.results[0]) {
            const { address1, address2, prefcode } = data.results[0];
            this._addressHint.textContent = `${address1} ${address2}`;
            this._addressHint.hidden = false;
            this._currentPrefectureCode = parseInt(prefcode, 10) || null;
            if (this._currentPrefectureCode) {
              this.fetchShippingFee();
            } else {
              this.clearShippingFee();
            }
          } else {
            this._addressHint.textContent = '';
            this._addressHint.hidden = true;
            this.clearShippingFee();
          }
        } catch {
          this._addressHint.textContent = '';
          this._addressHint.hidden = true;
          this.clearShippingFee();
        }
      }

      async fetchShippingFee() {
        const reqId = ++this._shippingFeeReqId;
        const sku = this.dataset.sku;
        const storeSlug = this.dataset.storeSlug || 'crash';
        const apiBase = (this.dataset.apiBase || 'https://stg.sk-bridge.online').replace(/\/$/, '');

        if (!sku || !this._currentPrefectureCode) {
          if (reqId !== this._shippingFeeReqId) return;
          if (this._shippingFeeDt) this._shippingFeeDt.hidden = true;
          if (this._shippingFeeRow) this._shippingFeeRow.hidden = true;
          if (this._shippingFeeText) {
            this._shippingFeeText.textContent = '';
            this._shippingFeeText.style.color = '';
          }
          return;
        }

        try {
          const response = await fetch(`${apiBase}/api/v1/shipping_fee`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{ product_code: sku, quantity: this._currentQuantity }],
              prefecture_code: this._currentPrefectureCode,
              store_slug: storeSlug,
            }),
          });

          if (reqId !== this._shippingFeeReqId) return;

          if (!response.ok) {
            throw { message: `送料の計算に失敗しました（${response.status}）。` };
          }

          const result = await response.json();

          if (reqId !== this._shippingFeeReqId) return;

          if (result.status !== 'success' || !result.data) {
            throw { message: '送料情報を取得できませんでした。' };
          }

          const totalFee = result.data.total_shipping_fee;
          let feeText;
          if (totalFee === 0) {
            feeText = '基本送料無料';
          } else {
            feeText = `${totalFee.toLocaleString('ja-JP')}円`;
          }

          if (this._shippingFeeText) {
            this._shippingFeeText.textContent = feeText;
            this._shippingFeeText.style.color = '';
          }
          if (this._shippingFeeDt) this._shippingFeeDt.hidden = false;
          if (this._shippingFeeRow) this._shippingFeeRow.hidden = false;
        } catch (err) {
          if (reqId !== this._shippingFeeReqId) return;
          console.error('[shipping-fee]', err);
          if (this._shippingFeeText) {
            this._shippingFeeText.textContent = '';
            this._shippingFeeText.style.color = '';
          }
          if (this._shippingFeeDt) this._shippingFeeDt.hidden = true;
          if (this._shippingFeeRow) this._shippingFeeRow.hidden = true;
        }
      }

      async fetchDelivery() {
        const sku = this.dataset.sku;
        const comment = this.dataset.comment || '';
        const storeSlug = this.dataset.storeSlug || 'honten';
        const apiBase = (this.dataset.apiBase || 'https://stg.sk-bridge.online').replace(/\/$/, '');
        const postalCode = this._postalInput.value.replace(/-/g, '').trim();

        if (!sku) return;

        this._loadingRow.hidden = false;
        this._resultDt.hidden = true;
        this._resultRow.hidden = true;
        this._errorRow.hidden = true;
        this._errorRow.textContent = '';

        try {
          const params = new URLSearchParams({
            store_slug: storeSlug,
            prod_code: sku,
            post_code: postalCode,
          });

          const response = await fetch(`${apiBase}/api/v1/ec_delivery?${params}`, {
            headers: { Accept: 'application/json' },
          });

          // HTTPエラー別メッセージ
          if (!response.ok) {
            const messages = {
              400: 'リクエストに問題が発生しました。',
              404: '商品情報が見つかりませんでした。',
              500: '一時的なエラーが発生しました。しばらくしてからお試しください。',
            };
            throw { type: 'http', message: messages[response.status] || `エラーが発生しました（${response.status}）。` };
          }

          const data = await response.json();

          // validated: false → 郵便番号不正 or 存在しない
          if (!data.validated) {
            throw { type: 'postal', message: '入力した郵便番号が正しくないか、存在しません。' };
          }

          // estimated_date が null → 日付未確定
          if (!data.estimated_date) {
            throw { type: 'no_date', message: '現在お届け日を計算できません。' };
          }

          const arrivalEstimate = formatArrivalEstimate(data.estimated_date);

          // custom.short_delivery_until の当日までは固定文言に差し替え（日本時間の日付で判定）
          const overrideUntil = (this.dataset.shortDeliveryUntil || '').slice(0, 10);
          const todayJST = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo' }).format(new Date());

          if (overrideUntil && todayJST <= overrideUntil) {
            this._resultText.textContent = '1-3営業日以内の発送';
          } else if (arrivalEstimate && data.is_reservation) {
            this._resultText.textContent = arrivalEstimate;
          } else {
            const date = new Date(data.estimated_date);
            const days = ['日', '月', '火', '水', '木', '金', '土'];
            const dateLabel = `${date.getMonth() + 1}/${date.getDate()}(${days[date.getDay()]})`;
            const commentText = comment ? `（${comment}）` : '';

            this._resultText.textContent = `${dateLabel}以降のお届け${commentText}`;
          }
          this._resultDt.hidden = false;
          this._resultRow.hidden = false;
        } catch (err) {
          console.error('[delivery-date]', err);
          this._resultDt.hidden = true;
          this._resultRow.hidden = true;
          this._errorRow.textContent = err.message || 'エラーが発生しました。';
          this._errorRow.hidden = false;
        } finally {
          this._loadingRow.hidden = true;
        }
      }
    }
  );
}
